import {CareerSubjectRecommendation, Subject} from "jobjump-types/Subjects";
import { fetchWithAuth } from "./Utils";

const Subjects = {
    getSubjects : () : Promise<Subject[]> =>
        fetchWithAuth("/api/subjects").then(r => r.json()).catch(console.log),
    getSubjectsForSchoolId : (schoolId:string) : Promise<Subject[]> =>
        fetchWithAuth("/api/subjects/school?schoolId="+schoolId).then(r => r.json()).catch(console.log),
    getVETSubjects : () : Promise<Subject[]> =>
        fetchWithAuth("/api/subjects/vet").then(r => r.json()).catch(console.log),
    getSubjectsForCareer : (careerId:string) : Promise<CareerSubjectRecommendation[]> =>
        fetchWithAuth("/api/subjects/career/"+careerId).then(r => r.json()).catch(console.log),
}

export default Subjects;